import { type SlotGameStore, type Sprite } from "@gamzix/slot_core";
import { CONST } from "../../../src/const";

class HeapFeatureDataStore {
    static currentLevel = null;
    static previousLevel = 0;
    static MIN_LEVEL = 0;
    static MAX_LEVEL = 5;
    static TIME_MOVE_MAP = {
        NORMAL_SPIN: 700,
        FAST_SPIN: 400,
        TURBO_SPIN: 200
    };
    static TIME_COMMON_SHAKING_ANIMATION = 800;
    static TIME_HEAP_COLLECT_ANIMATION = 1000;
    static bonusSymbolsId: number[] = [0, 11]
    static nameAnimations = {
        win: {
            level_0: "win_stage0",
            level_1: "win_stage1",
            level_2: "win_stage2",
            level_3: "win_stage3",
            level_4: "win_stage4",
            level_5: "win_stage5",
        },
        upgrade: {
            level_1: "upgrade0-1",
            level_2: "upgrade1-2",
            level_3: "upgrade2-3",
            level_4: "upgrade3-4",
            level_5: "upgrade4-5",
        },
        end: {
            level_0: "end_stage0",
            level_1: "end_stage1",
            level_2: "end_stage2",
            level_3: "end_stage3",
            level_4: "end_stage4",
            level_5: "end_stage5",
        },
        collect: {
            level_0: "collect_stage0",
            level_1: "collect_stage1",
            level_2: "collect_stage2",
            level_3: "collect_stage3",
            level_4: "collect_stage4",
            level_5: "collect_stage5",
        },
    }

    static getTimeByGameMode(timeMap) {
        const { gameSettings } = this.store;

        if (gameSettings.isNormalSpin) {
            return timeMap.NORMAL_SPIN;
        } else if (gameSettings.isFastSpin) {
            return timeMap.FAST_SPIN;
        } else if (gameSettings.isTurboSpin) {
            return timeMap.TURBO_SPIN;
        }
    }

    static get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    static get currentTimeMove() {
        return HeapFeatureDataStore.getTimeByGameMode(HeapFeatureDataStore.TIME_MOVE_MAP);
    }

    static get isSpinHaveWin() {
        return HeapFeatureDataStore.store.gameData.spinWinAmount !== 0;
    }

    static get isSpinHaveHeapTriggerBonus() {
        return !!HeapFeatureDataStore.store.gameData.replace.length
    }

    static get isCanRunFlyIntoHeap() {
        const isNotBonusGame = !this.store.gameData.bonusGame.isPlaying();
        const isNotRunTriggerBonus = !this.isSpinHaveHeapTriggerBonus;
        const isNotStartedBonusGame = !(this.store.gameData.bonusGame.isStarted())
        const isPrevModeNotBonus = !(this.store.gameData.prevMode === "bonus") //Так як не можу використати this.store.gameData.bonusGame.isFinished()
        const isNotBeforeStartFreeSpinsGame = !this.isCanFlyStarsIntroHeapBeforeStartFreeSpinsGame

        return this.getIsReelHaveBonusSymbols() && isNotBonusGame && isNotRunTriggerBonus && isNotStartedBonusGame && isPrevModeNotBonus && isNotBeforeStartFreeSpinsGame
    }
    static get isCanFlyStarsIntroHeapBeforeBonusWin() {
        const isBonusGameStarted = this.store.gameData.mode === "bonus" && (this.store.gameData.prevMode === "main" || this.store.gameData.prevMode === "freespins")
        const isSpinNotHaveHeapTriggerBonus = !this.isSpinHaveHeapTriggerBonus

        return this.getIsReelHaveBonusSymbols() && isBonusGameStarted && isSpinNotHaveHeapTriggerBonus
    }
    static get isCanFlyStarsIntroHeapBeforeStartFreeSpinsGame() {
        const isStartFreeSpinsGame = this.store.gameData.freeSpinsGame.isStarted();

        return this.getIsReelHaveBonusSymbols() && isStartFreeSpinsGame
    }

    static getIsFinishedFreeSpinsGame() {
        return (
            this.store.gameData.freeSpinsGame.isFinished() &&
            !this.store.gameData.bonusGame.isStarted() &&
            !this.store.gameData.bonusGame.isPlaying()
        );
    }

    static getIsReelHaveBonusSymbols() {
        let isHave = false

        for (let reelId = 0; reelId < CONST.COLUMNS; reelId++) {
            for (let rowId = 0; rowId < CONST.ROWS; rowId++) {
                const symbolData = this.store.gameData.reels[reelId][rowId];
                const isSymbolValid = this.bonusSymbolsId.includes(Number(symbolData?.symbol));

                if (isSymbolValid) {
                    isHave = true;
                }
            }
        }
        return isHave;
    }

    static isShowFlyStarInFinishFreeSpinsGame() {
        return this.getIsFinishedFreeSpinsGame() && this.getIsReelHaveBonusSymbols()
    }

    static getCurrentNameAnimation(type) {
        const level = this.previousLevel > this.currentLevel ? this.previousLevel : this.currentLevel;
        const currentNameAnimation = this.nameAnimations[type][`level_${level}`];

        return currentNameAnimation;
    }

    static getCurrentLevelSprite(level) {
        const isNotValidLevel = !(level >= this.MIN_LEVEL && level <= this.MAX_LEVEL);
        if (isNotValidLevel) return

        const currentTextureName = `counter_jp_${level}`;
        const currentSprite = this.createSprite(currentTextureName);

        return currentSprite
    }

    static createSprite(nameTexture) {
        return <Sprite>game.builder.create(<any>{
            "type": "Sprite",
            "texture": nameTexture,
            "name": nameTexture,
        });
    }
}

export { HeapFeatureDataStore }
